import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

export function omitByEmptyKeepBooleans(params) {
  return omitBy(params, (value) => {
    if (value === null || value === undefined) return true
    if (typeof value === 'string' && value.trim() === '') return true
    if (Array.isArray(value) && value.length === 0) return true
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
      return true
    }
    return false
  })
}

function buildParamList(params, encoded = false) {
  if (isEmpty(params)) return ''
  return encoded ? buildEncodedParamList(params) : buildPlainParamList(params)
}

function buildPlainParamList(params) {
  try {
    let returnedParams = '?'
    if (typeof params === 'object') {
      const allParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc.push(`${key}=${value.join()}`)
        } else {
          acc.push(`${key}=${value}`)
        }
        return acc
      }, [])
      returnedParams += allParams.join('&')
    }
    return returnedParams
  } catch (error) {
    return new Error(error)
  }
}

const buildEncodedParamList = (params) => {
  const filteredParams = omitBy(params, isEmpty)
  const searchParams = new URLSearchParams()

  Object.entries(filteredParams).forEach(([key, value]) => {
    const valueToAppend = Array.isArray(value) ? value.join(',') : String(value)
    searchParams.append(key, valueToAppend)
  })

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

export default buildParamList
